import styles from './ProjectDevices.module.css';

import settingsIcon from 'assets/svg/settings-01.svg';
import arrowIcon from 'assets/svg/arrow-01.svg';

import { observer } from 'mobx-react-lite';
import { projectsStore } from 'store/mobx/projects.store';
import Card from 'ui/Card';
import IconButton from 'ui/IconButton';
import RegularButton from 'ui/RegularButton';
import Icon from 'ui/Icon';
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { devicesStore } from 'store/mobx/devices.store';

const MAX_VISIBLE_DEVICES_PREVIEW = 4;

const ProjectDevices = observer(({ setModalOpened }) => {
  const { selectedProject } = projectsStore;
  const { getListDevices } = devicesStore;
  const [expandProjectDevicesPreview, setExpandProjectDevicesPreview] = useState(false);
  const [projectDevices, setProjectDevices] = useState([]);

  const handleEditProjectDevicesClick = () => setModalOpened(true);

  useEffect(() => {
    loadDevices();
  }, []);

  const loadDevices = async () => {
    await getListDevices();
  };

  useEffect(() => {
    if (!selectedProject?.devices) return;
    const maxVisibleItems = selectedProject?.devices?.slice(
      0,
      expandProjectDevicesPreview ? selectedProject?.devices?.length : MAX_VISIBLE_DEVICES_PREVIEW,
    );
    setProjectDevices(maxVisibleItems);
  }, [selectedProject?.devices, expandProjectDevicesPreview]);

  const DeviceModel = ({ model, key }) => {
    return (
      <div key={key}>
        <span>{model.device_model?.name}</span>&nbsp;&nbsp;&nbsp;&nbsp;
        {model.device?.name ? (
          <>
            <span className={styles.deviceItem}>инв. {model.device?.inventory_number}</span>
            &nbsp;&nbsp;-&nbsp;&nbsp;
            <span>{model.device?.name}</span>
          </>
        ) : (
          <span className={styles.deviceItem}>&nbsp;не выбрано</span>
        )}
      </div>
    );
  };

  return (
    <Card>
      <Card.Title text={'Оборудование проекта'}>
        <IconButton
          tooltip={'Настройки'}
          icon={settingsIcon}
          onClick={handleEditProjectDevicesClick}
        />
      </Card.Title>
      <Card.Content className={styles.projectDevicesInfo}>
        <div className={styles.items}>
          {projectDevices?.length ? (
            projectDevices.map((model) => <DeviceModel model={model} key={model.device_model.id} />)
          ) : selectedProject?.id_scheme ? (
            <div>Оборудование в схеме отсутствует</div>
          ) : (
            <div>Не выбрана производственная схема</div>
          )}
        </div>
        <RegularButton
          className={styles.expandButton}
          text={expandProjectDevicesPreview ? 'Свернуть' : 'Развернуть'}
          variant={'outlined'}
          color={'secondary'}
          onClick={() => setExpandProjectDevicesPreview(!expandProjectDevicesPreview)}
          disabled={
            !projectDevices?.length ||
            selectedProject?.devices?.length <= MAX_VISIBLE_DEVICES_PREVIEW
          }
          appendIcon={
            <Icon
              className={classNames(styles.expandIcon, {
                [styles.expandedIcon]: expandProjectDevicesPreview,
              })}
              color={'var(--color-secondary)'}
              src={arrowIcon}
              width={'14px'}
              height={'14px'}
            />
          }
        />
      </Card.Content>
    </Card>
  );
});

export default ProjectDevices;
